import { Container } from "components/Container";
import { Required } from "components/Required";
import { Col, Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useProxy } from "../../../../Hooks/useProxy";
import { ICadastroProxy } from "../../../../Interfaces/ICadastroProxy";
import { Button, ButtonEnviar } from "../../style";

interface ICadastroProxyProps {
  listarProxys: () => any;
}

export function CadastroProxy({ listarProxys }: ICadastroProxyProps) {
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<ICadastroProxy>();

  const { loading, cadastroProxy } = useProxy();

  function handleBaixarModelo() {
    const link = document.createElement("a");
    link.download = "Modelo_cadastrar_proxy.xlsx";
    link.href = "/app/files/Modelo_cadastrar_proxy.xlsx";
    link.click();
  }

  async function submitFormulario(dados: ICadastroProxy) {
    await cadastroProxy(dados);
    listarProxys();
  }

  return (
    <Container titulo="Cadastro Proxy">
      <>
        <form onSubmit={handleSubmit(submitFormulario)}>
          <Row>
            <Col md={6}>
              <Form.Group>
                <Form.Label>
                  Planilha de proxy <Required />
                </Form.Label>
                <br />

                <Controller
                  name="file"
                  control={control}
                  render={({ field: { onChange } }) => (
                    <input
                      type="file"
                      onChange={(event) => {
                        onChange(event.target.files?.[0]);
                      }}
                      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    />
                  )}
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label>
                  Fornecedor <Required />
                </Form.Label>
                <Controller
                  name="fornecedor"
                  control={control}
                  defaultValue="proxyscrape"
                  rules={{ required: "Informe o fornecedor." }}
                  render={({ field }) => (
                    <Form.Select {...field}>
                      <option value="proxyscrape">proxyscrape</option>
                      <option value="scrapeless">scrapeless</option>
                      <option value="brightdata">brightdata</option>
                    </Form.Select>
                  )}
                />
                {errors.fornecedor && (
                  <Form.Text className="text-danger">
                    {errors.fornecedor.message}
                  </Form.Text>
                )}
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={2}>
              <ButtonEnviar disabled={loading}>
                {loading ? "Carregando" : "Enviar"}{" "}
              </ButtonEnviar>
            </Col>
            <Col md={2}>
              <Button
                outline
                variante="primary"
                type="button"
                onClick={handleBaixarModelo}
              >
                Baixar modelo
              </Button>
            </Col>
          </Row>
        </form>
      </>
    </Container>
  );
}
